import { useLocation } from 'react-router';
import { Card } from '../Card';
import { cards } from '../../routes';
import './CardsList.scss';

export const CardsList = () => {
  const location = useLocation();
  return (
    <div className='row g-4'>
      {cards
        .filter(card => card.path !== location.pathname)
        .map(card => (
          <div className='col-12 col-sm-6 col-md-4' key={card.title}>
            <Card title={card.title} text={card.text} path={card.path} />
          </div>
        ))}
    </div>
  );
};
